import { TaskCompletion } from 'graphql-common';
import _get from 'lodash/get';
import { TFunction } from 'i18next';
import Icons from '@lib/components/Icons/Icons';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';

export default function getTaskCompletionsTableActionsMenu({
  t,
  // Optional: omit to drop the "Completion details" item (the user app).
  onViewCompletion,
  // Optional: the user app's completions modal is read-only and has no
  // create-intervention entry point from here — omit it to drop the menu
  // item entirely rather than passing a no-op.
  onCreateIntervention,
  onViewIntervention,
}: {
  t: TFunction<'translation', undefined>;
  onViewCompletion?: (item?: TaskCompletion) => void;
  onCreateIntervention?: (item?: TaskCompletion) => void;
  onViewIntervention: (item?: TaskCompletion) => void;
}): NavItem<TaskCompletion>[] {
  return [
    ...(onViewCompletion
      ? [
          {
            id: 'view-action',
            title: t('completion-details'),
            onClick: (item?: TaskCompletion) => onViewCompletion(item),
            leftIcon: Icons.view,
            type: NavItemTypeEnum.Secondary,
          },
        ]
      : []),
    ...(onCreateIntervention
      ? [
          {
            id: 'create-intervention',
            title: t('create-intervention'),
            onClick: (item?: TaskCompletion) => onCreateIntervention(item),
            leftIcon: Icons.build,
            type: NavItemTypeEnum.Secondary,
            predictorFnVisible: (item?: TaskCompletion) =>
              !!_get(item, 'task.canInterventionCreate.value'),
          },
        ]
      : []),
    {
      id: 'view-intervention',
      title: t('view-intervention'),
      onClick: (item) => onViewIntervention(item),
      leftIcon: Icons.build,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: (item) => !!_get(item, 'task.intervention.id'),
    },
  ];
}
